import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Componente", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecciona un componente", -1 /* HOISTED */)
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Cabecera ", -1 /* HOISTED */)
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Mostrar Modal ", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Parámetros", -1 /* HOISTED */)
const _hoisted_12 = { class: "tableParameters" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      name: "dslist",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedComponent) = $event)),
      style: {"border":"1px solid #999","border-radius":"30px","font-size":"110%"},
      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeComponent())),
      class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dtComponentsInfo, (ds, index) => {
        return (_openBlock(), _createElementBlock("option", {
          value: ds.id,
          key: index
        }, _toDisplayString('(' + ds.id + ') - ' + ds.name), 9 /* TEXT, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
      [_vModelSelect, _ctx.selectedComponent]
    ]),
    (_ctx.selectedComponent)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onPointerdown: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"])),
          onDblclick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"])),
          style: {"overflow-y":"auto","overflow-x":"hidden","height":"200px"}
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("textarea", {
              style: {"resize":"none"},
              onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
              onDblclick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
              id: "header",
              name: "header",
              rows: "2",
              cols: "50",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedComponentHeader) = $event)),
              class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full",
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeComponentHeader && _ctx.changeComponentHeader(...args)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, _ctx.selectedComponentHeader]
            ]),
            _createElementVNode("i", {
              onPointerdown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
              onDblclick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
              "aria-hidden": "true",
              class: "fa fa-subscript",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showExpression(_ctx.DisplayComponentNodeConst.VAR_HEADER_IN, 'Cabecera a mostrar')))
            }, null, 32 /* HYDRATE_EVENTS */)
          ]),
          _hoisted_7,
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "modal",
            name: "modal",
            onPointerdown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
            onDblclick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedComponentModalInput) = $event)),
            onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.changeComponentModal && _ctx.changeComponentModal(...args)))
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelCheckbox, _ctx.selectedComponentModalInput]
          ]),
          _createElementVNode("i", {
            onPointerdown: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
            onDblclick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
            "aria-hidden": "true",
            class: "fa fa-subscript",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showExpression(_ctx.DisplayComponentNodeConst.VAR_COMPMODAL_IN, 'Mostrar modal del componente')))
          }, null, 32 /* HYDRATE_EVENTS */),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Nombre', 'Valor', ''], (column, index) => {
                  return _createElementVNode("th", { key: index }, _toDisplayString(column), 1 /* TEXT */)
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dtComponentsVarInfo, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['name'], (column, indexColumn) => {
                    return _createElementVNode("td", { key: indexColumn }, _toDisplayString(item[column]), 1 /* TEXT */)
                  }), 64 /* STABLE_FRAGMENT */)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      onPointerdown: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
                      onDblclick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
                      type: "text",
                      onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changeVariableValue())),
                      "onUpdate:modelValue": ($event: any) => ((item['value']) = $event),
                      class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13), [
                      [_vModelText, item['value']]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("i", {
                      onPointerdown: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
                      onDblclick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
                      "aria-hidden": "true",
                      class: "fa fa-subscript",
                      onClick: ($event: any) => (_ctx.showExpression(_ctx.DisplayComponentNodeConst.VAR_PARAM_IN, item.name, item))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_14)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ], 32 /* HYDRATE_EVENTS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}